import { FormattedMessage, FormattedTime } from "react-intl";

import Nbsp from "@components/Nbsp";
import useGetMyTimeWithTimezoneAbbreviation from "@hooks/useGetMyTimeWithTimezoneAbbreviation";

type Props = {
  endTime: Date;
  startTime: Date;
};

const TimeRange = ({ endTime, startTime }: Props) => {
  const getMyTimeWithTimezoneAbbreviation = useGetMyTimeWithTimezoneAbbreviation();

  return (
    <>
      <FormattedTime value={startTime} />
      <Nbsp />
      <FormattedMessage id="dictionary.to" />
      <Nbsp />
      {getMyTimeWithTimezoneAbbreviation(endTime)}
      <Nbsp />
    </>
  );
};

export default TimeRange;
